import { Address, Scalars } from '../../types/generated';
import { apiMutate } from '../../utils/mutation';
import { addAddressMutation } from '../../mutations/address';
import ServiceConfigs from '../../config';
import { useAddressBook } from '.';

type UseAddAddressType = ({
  currentAreaId,
}: {
  currentAreaId?: string;
}) => ({
  areaId,
  street,
  unitType,
  unitNo,
  block,
  building,
  floor,
  avenue,
  notes,
  lng,
  lat,
  phoneNumber,
}: {
  areaId: Scalars['Int'];
  street: string;
  unitType: string;
  unitNo: string;
  block?: string;
  building?: string;
  floor?: string;
  avenue?: string;
  notes?: string;
  lng?: string;
  lat?: string;
  phoneNumber?: string;
}) => Promise<Partial<Address>>;

const useAddAddress: UseAddAddressType = ({ currentAreaId }) => {
  const { data: addressBook, mutate: mutateAddressBook } = useAddressBook({ areaId: currentAreaId });
  return variables =>
    apiMutate({
      mutation: addAddressMutation,
      variables: { ...variables, subdomain: ServiceConfigs.getSubDomain() },
      requestHeaders: { ...ServiceConfigs.getAuthorizationHeader() },
      handler: (res: any) => res?.addAddress,
    }).then((newAddress: Address) => {
      const newlyAddedAddress = { ...newAddress, covered: true };
      if (newAddress)
        mutateAddressBook(
          {
            ...addressBook,
            addresses: [...addressBook.addresses, newlyAddedAddress]?.sort(address => (address.covered ? -1 : 1)),
          },
          false,
        );
      return newAddress;
    });
};

export default useAddAddress;
